



































































import {
  Component,
  PropSync,
  Prop,
  Ref,
  Emit,
  Vue
} from 'vue-property-decorator';
import LbzDivider from '../divider/divider.vue';
import LbzIconButton from '../icon-button/icon-button.vue';

@Component({
  components: {
    LbzDivider,
    LbzIconButton
  }
})
export default class LbzBackdrop extends Vue {
  // [required]active.sync: true, false
  @PropSync('active', { type: Boolean, required: true })
  private cisActive!: boolean;

  // background (auto-darkened): 'primary' (default), 'secondary', 'surface', 'light', 'dark'
  @Prop({ type: String, default: '' }) private background!: string;
  // subheader: '' (default), 'x'
  @Prop({ type: String, default: '' }) private subheader!: string;
  // icon: true, false (default)
  @Prop({ type: Boolean, default: false }) private icon!: boolean;
  // divider: true, false (default)
  @Prop({ type: Boolean, default: false }) private divider!: boolean;
  // horizontal: true, false (default)
  @Prop({ type: Boolean, default: false }) private horizontal!: boolean;
  // scrim: true, false (default)
  @Prop({ type: Boolean, default: false }) private scrim!: boolean;

  @Ref('scroller') private rscroller!: HTMLElement;

  private ftoggle(): void {
    this.cisActive = !this.cisActive;
  }

  private fopen(): void {
    this.cisActive = true;
  }

  private fclose(): void {
    this.cisActive = false;
  }

  private fscrollToTop(): void {
    this.rscroller.scrollTo(0, 0);
  }

  @Emit('scroll')
  private fscroll(e: Event, position: VueScrollPosition) {
    return this.rscroller;
  }
}
